import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import { ROLES } from '@/lib/auth/roles'
import { isCurrentPage, validateSearchWithDefaults } from '@/lib/utils'
import { reportQueryOptions, risksOrOpportunitiesQueryOptions } from '@/modules/client-actions-report/hooks/hooks'
import Risk from '@/modules/client-actions-report/risk'
import { ClientActionsReportType, ClientActionsTypes } from '@/types/enums/client-actions'
import {
  ClientActionsReportRiskSearch, defaultFetchParamsReport,
  defaultFetchParamsReportRisksOrOpportunities, mergedReportRiskSchema,
} from '@/types/route-search-schemas'
import { DataLoader } from '@/types/router-context'
import {RISK_REPORT_PATH, RISK_REPORT_URL} from '@/utils/urls'

export const Route = createFileRoute(RISK_REPORT_PATH)({
  component: RiskReport,
  validateSearch: (search: Record<string, unknown>): ClientActionsReportRiskSearch => {
    const tab = String(search.tab ?? 'report')
    return validateSearchWithDefaults(mergedReportRiskSchema, { tab, ...search })
  },
  loader: ({ context: { queryClient, date, roles } }: DataLoader) => {
    if (isCurrentPage(RISK_REPORT_URL)) {
      return
    }
    if (roles.includes(ROLES.ROLE_ELEVATION)) {
      queryClient.prefetchQuery(reportQueryOptions(date, defaultFetchParamsReport, ClientActionsReportType.RISK))
      queryClient.prefetchQuery(risksOrOpportunitiesQueryOptions(date, defaultFetchParamsReportRisksOrOpportunities, ClientActionsTypes.RISKS))
    }
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Client actions', path: '#' },
        { label: 'Potential risks', path: '/' }
      ],
    }
  },
})

function RiskReport() {
  return (
    <div className='flex flex-col items-center justify-center max-sm:p-5'>
      <Authorisation
        roles={[ROLES.ROLE_ELEVATION]}
        permissions={[]}
        forbiddenFallback={<Unauthorized />}
      >
        <Risk />
      </Authorisation>
    </div>
  )
}
